import produce from 'immer'
import { CaseworkerActionType } from '../../action-types'
import { CaseworkerAction } from '../../actions'
import { ReportListItem } from '../../../ts/api-types'

export interface CaseworkerReportsState {
    ownReports: ReportListItem[]
    allReports: ReportListItem[]
    allReportsFiltered: ReportListItem[]
    allReportsFilteredCaseType: 'all' | 'mine'
    allReportsFilteredStatus: string | null
    allReportsSearchString: string
    closedReports: ReportListItem[]
    closedReportsFiltered: ReportListItem[]
    closedReportsSearchString: string
    currentUserId: number | null
}

const initialState: CaseworkerReportsState = {
    ownReports: [],
    allReports: [],
    allReportsFiltered: [],
    allReportsFilteredCaseType: 'all',
    allReportsFilteredStatus: null,
    allReportsSearchString: '',
    closedReports: [],
    closedReportsFiltered: [],
    closedReportsSearchString: '',
    currentUserId: null,
}

const checkIfFieldIncludesString = (field: string | null, search: string) =>
    field != null && field.toLowerCase().includes(search.toLowerCase())

const reducer = produce(
    (
        state: CaseworkerReportsState = initialState,
        action: CaseworkerAction
    ) => {
        switch (action.type) {
            case CaseworkerActionType.GET_SELF:
                state.currentUserId = action.payload.id
                return state

            case CaseworkerActionType.GET_OWN_REPORTS:
                state.ownReports = action.payload
                return state

            case CaseworkerActionType.GET_ALL_REPORTS:
                state.allReports = action.payload
                state.allReportsFiltered = action.payload
                return state

            case CaseworkerActionType.GET_CLOSED_REPORTS:
                state.closedReports = action.payload
                state.closedReportsFiltered = action.payload
                return state

            case CaseworkerActionType.SEARCH_ALL_CASES:
                state.allReportsSearchString = action.payload.searchValue
                return state

            case CaseworkerActionType.ADD_STATUS_FILTER:
                if (state.allReportsFilteredStatus === action.payload.status) {
                    state.allReportsFilteredStatus = null
                } else {
                    state.allReportsFilteredStatus = action.payload.status
                }
                return state

            case CaseworkerActionType.ADD_CASE_TYPE_FILTER:
                state.allReportsFilteredCaseType = action.payload.type
                return state

            case CaseworkerActionType.FILTER_ALL_CASES: {
                const { allReportsSearchString } = state

                const filteredReports = state.allReports.filter((report) => {
                    let returnReport
                    if (
                        !allReportsSearchString ||
                        checkIfFieldIncludesString(
                            report.uuid,
                            allReportsSearchString
                        ) ||
                        checkIfFieldIncludesString(
                            report.organizationName,
                            allReportsSearchString
                        ) ||
                        checkIfFieldIncludesString(
                            report.title,
                            allReportsSearchString
                        ) ||
                        checkIfFieldIncludesString(
                            report.assignedToName,
                            allReportsSearchString
                        ) ||
                        // TODO remove category filter
                        // when category is removed from preview
                        checkIfFieldIncludesString(
                            report.category,
                            allReportsSearchString
                        )
                    ) {
                        if (
                            state.allReportsFilteredStatus ||
                            state.allReportsFilteredCaseType !== 'all'
                        ) {
                            if (
                                !state.allReportsFilteredStatus ||
                                report.status ===
                                    state.allReportsFilteredStatus
                            ) {
                                if (
                                    state.allReportsFilteredCaseType === 'all'
                                ) {
                                    returnReport = true
                                } else {
                                    if (
                                        report.assignedToId ===
                                        state.currentUserId
                                    ) {
                                        returnReport = true
                                    } else {
                                        returnReport = false
                                    }
                                }
                            }
                        } else {
                            returnReport = true
                        }
                    } else {
                        returnReport = false
                    }

                    return returnReport
                })
                state.allReportsFiltered = filteredReports

                return state
            }

            case CaseworkerActionType.REMOVE_ALL_FILTERS:
                state.allReportsFilteredCaseType = 'all'
                state.allReportsSearchString = ''
                state.allReportsFilteredStatus = null
                state.allReportsFiltered = state.allReports
                return state

            case CaseworkerActionType.SEARCH_CLOSED_REPORTS: {
                state.closedReportsSearchString = action.payload.searchValue
                const { closedReportsSearchString } = state

                const filteredClosedReports = state.closedReports.filter(
                    (report: ReportListItem) => {
                        let returnReport
                        returnReport =
                            !closedReportsSearchString ||
                            checkIfFieldIncludesString(
                                report.uuid,
                                closedReportsSearchString
                            ) ||
                            checkIfFieldIncludesString(
                                report.organizationName,
                                closedReportsSearchString
                            ) ||
                            checkIfFieldIncludesString(
                                report.title,
                                closedReportsSearchString
                            ) ||
                            checkIfFieldIncludesString(
                                report.assignedToName,
                                closedReportsSearchString
                            ) ||
                            checkIfFieldIncludesString(
                                report.category,
                                closedReportsSearchString
                            )
                        return returnReport
                    }
                )
                state.closedReportsFiltered = filteredClosedReports

                return state
            }

            default:
                return state
        }
    }
)

export default reducer
